import { MdFiberManualRecord as FiberManualRecordIcon } from 'react-icons/md';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import {
  Divider,
  Theme,
  Tooltip,
  TooltipProps,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material';

const ConnectorsTooltip: FC<
  React.PropsWithChildren<ConnectorsTooltipProps>
> = ({
  children,
  displayName,
  statusColor,
  title,
  placement = 'top',
  isBuiltIn,
}) => {
  const { classes } = useStyles();
  const theme = useTheme();

  return (
    <Tooltip
      arrow
      placement={placement}
      title={
        <div>
          <div className={classes.connectorTooltipTitle}>
            <Typography variant='body1' fontWeight='bold' color='text.primary'>
              {displayName}
            </Typography>
            {isBuiltIn && (
              <Typography variant='body2' color='primary'>
                By OX
              </Typography>
            )}
          </div>
          <Divider />
          <div className={classes.connectorTooltipContent}>
            <FiberManualRecordIcon
              style={{
                fontSize: '12px',
                color: theme.palette.badge[statusColor],
                display: 'inline-block',
              }}
            />
            <Typography
              variant='body1'
              color='text.primary'
              mx={1}
              component='span'>
              {title}
            </Typography>
          </div>
        </div>
      }>
      <div>{children}</div>
    </Tooltip>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  connectorTooltipContent: {
    minWidth: 200,
    padding: `${theme.spacing(1)}`,
  },
  connectorTooltipTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: `${theme.spacing(1)}`,
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

export interface ConnectorsTooltipProps {
  statusColor: string;
  title: string;
  displayName: string;
  placement?: TooltipProps['placement'];
  isBuiltIn: boolean;
}

export default ConnectorsTooltip;
